<template>
  <Toast />
  <Message v-if="!service_enabled" severity="warn">DNS service is disabled for this domain</Message>
  <Breadcrumb :home="bc_home" :model="bc_items" />

  <div class="dns p-pt-1">
    <Card v-if="DNSRecords" class="">
        <template #title>
          <Button icon="pi pi-plus" class="p-button-rounded p-button-primary" @click="openNewRecordModal" />
          <!-- <Button class="p-button-lg p-button-rounded p-button-text p-button-plain" icon="pi pi-cog" @click="openNewRecordModal"  v-tooltip.bottom="'Settings'"/> -->
        </template>
        <template #content>
          <DataTable :value="DNSRecords.records" class="p-datatable-sm" responsiveLayout="stack" @row-click="openRecordModal($event)" rowHover stripedRows selectionMode="single">
              <template #empty>
                <span style="text-align: center">No records found</span>
              </template>
              <Column field="name" header="Name">
                <template #body="slotProps">
                  <div class="p-text-nowrap p-text-truncate truncate-name">{{ slotProps.data.name }}</div>
                </template>
              </Column>
              <Column field="type" header="Type"></Column>
              <Column field="content" header="Content">
                <template #body="slotProps">
                  <div class="p-text-nowrap p-text-truncate truncate-content">{{ slotProps.data.content }}</div>
                </template>
              </Column>
              <Column field="ttl" header="TTL"></Column>
              
              <Column header="Active" headerStyle="width: 100px; text-align: right">
                  <template #body="slotProps">
                    <i v-if="slotProps.data.is_enabled" style="color:var(--green-400)" class="pi pi-check-circle"></i>
                    <i v-else style="color:var(--orange-400)" class="pi pi-minus-circle"></i>
                  </template>
              </Column>
          </DataTable>
        </template>
    </Card>
    <div v-else>
      No records
    </div>
  </div>
  <Dialog header="New Record" v-model:visible="displayNewRecordModal" :modal="true">
      <div class="new-record">
          <form class="p-fluid" autocomplete="off" v-on:submit.prevent>
              <div class="p-field p-mb-4 p-mt-4">
                  <div class="p-float-label">
                      <InputText id="name" v-model="record.name" autocomplete="off" autofocus />
                      <label for="name">Name</label>
                      <small class="p-error" v-if="errors.name">{{ errors.name }}</small>
                  </div>
              </div>
              <div class="p-field p-mb-4">
                  <div class="p-float-label">
                    <Dropdown id="type" v-model="record.type" :options="record_types" placeholder="Type" />
                    <label for="type">Type</label>
                  </div>
              </div>
              <div class="p-field p-mb-4">
                  <div class="p-float-label">
                      <InputText id="content" v-model="record.content" autocomplete="off" v-on:keyup.enter="createRecord" />
                      <label for="content">Content</label>
                  </div>
              </div>
              <div class="p-field p-mb-4">
                  <div class="p-float-label">
                      <InputText id="ttl" v-model="record.ttl" autocomplete="off" />
                      <label for="ttl">TTL</label>
                  </div>
              </div>
              <!--<div class="p-field">
                  <div class="p-float-label">
                      <Dropdown id="domain" v-model="account.domain_id" :options="Domains.domains" optionLabel="name" optionValue="id" />    
                      <label for="domain">Domain *</label>
                  </div>
              </div>-->
              <div class="p-field-checkbox">
                  <Checkbox id="active" :binary="true" v-model="record.active"></Checkbox>
                  <label for="active">Active</label>
              </div>
              
          </form>
      </div>
      <template #footer>
        <Button label="Create" icon="pi pi-check-square" class="w-full" :loading="loading" @click="createRecord"></Button>
      </template>
  </Dialog>
  <Dialog header="Update Record" v-model:visible="displayRecordModal" :modal="true">
      <div class="record">
          <form autocomplete="off">
            <div class="p-fluid">
              <div class="p-field p-mb-4 p-mt-4">
                  <div class="p-float-label">
                      <InputText id="name" v-model="record.name" autocomplete="off" />
                      <label for="name">Name</label>
                      <small class="p-error" v-if="errors.name">{{ errors.name }}</small>
                  </div>
              </div>
              <div class="p-field p-mb-4">
                  <div class="p-float-label">
                    <Dropdown id="type" v-model="record.type" :options="record_types" placeholder="Type" />
                    <label for="type">Type</label>
                  </div>
              </div>
              <div class="p-field p-mb-4">
                  <div class="p-float-label">
                      <InputText id="content" v-model="record.content" autocomplete="off" />
                      <label for="content">Content</label>
                  </div>
              </div>
              <div class="p-field p-mb-4">
                  <div class="p-float-label">
                      <InputText id="ttl" v-model="record.ttl" autocomplete="off" />
                      <label for="ttl">TTL</label>
                  </div>
              </div>
              <!--<div class="p-field">
                  <div class="p-float-label">
                      <Dropdown id="domain" v-model="account.domain_id" :options="Domains.domains" optionLabel="name" optionValue="id" />    
                      <label for="domain">Domain *</label>
                  </div>
              </div>-->
              <div class="p-field-checkbox">
                  <Checkbox id="active" :binary="true" v-model="record.is_enabled"></Checkbox>
                  <label for="active">Active</label>
              </div>
            </div>
            <div class="grid">
              <div class="col-6">
                
              </div>
              <div class="col"> 
                
              </div>
            </div>
          </form>
      </div>
      <template #footer>
          <Button label="Delete" class="p-button-text p-button-danger" @click="deleteRecord(record)"></Button>
          <Button label="Update" icon="pi pi-check-square" :loading="loading" @click="saveRecord"></Button>
      </template>
  </Dialog>
  <ConfirmDialog></ConfirmDialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getAttributes } from "../helpers/attributes.js"
import DNSNavBar from '../components/DNSNavBar.vue'

export default {
  name: 'DNSRecords',
  components: {
    DNSNavBar,
  },
  data () {
    return {
      form: {
        label: ''
      },
      bc_home: {icon: 'pi pi-home', to: '/domains'},
      bc_items: [{icon: 'pi pi-spin pi-spinner'}],
      loading: false,
      errors: {},
      record: {ttl: 3600},
      displayNewRecordModal: false,
      displayRecordModal: false,
      record_types: ['A', 'AAAA', 'CAA', 'CNAME', 'MX', 'NS', 'SOA', 'SRV', 'TXT'],
      domain: {name: ""},
      service_enabled: true
    }
  },
  created: function () {
    // this.GetDNSRecords(this.$route.params.domain_id)
  },
  beforeMount(){
    this.GetDNSRecords(this.$route.params.domain_id)
  },
  computed: {
    ...mapGetters({ DNSRecords: 'StateDNSRecords'}),
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    current_domain() {
      return this.DNSRecords
    }
  },
  watch: {
    current_domain (d) {
      if (d.domain && d.domain.name.length) {
        this.domain = d
        this.domain_name = d.domain.name
        this.bc_items = [
          {label: d.domain.name, to: '/domains/'+this.$route.params.domain_id},
          {label: 'DNS', to: '/domains/'+this.$route.params.domain_id+'/dns'},
          //{label: 'Records'}
        ]

        const services = getAttributes(d.domain.attributes, 'services')

        if (services && services.dns && services.dns.enabled) {
          this.service_enabled = true
        }
        else {
          this.service_enabled = false 
        }
      }
    },
  },
  methods: {
    ...mapActions(['CreateDNSRecord', 'GetDNSRecords', 'UpdateDNSRecord', 'DeleteDNSRecord']),
    openNewRecordModal() {
      this.record = {id: '', name: '', content: '', type: 'A', ttl: '3600', active: true}
      this.displayNewRecordModal = true
    },
    openRecordModal(e) {
      const result = this.DNSRecords.records.find( ({ id }) => id === e.data.id );
      Object.assign(this.record, result)
      this.displayRecordModal = true
    },
    createRecord () {
      this.loading = true
      this.errors = {}
      
      this.record.domain_id = this.$route.params.domain_id

      this.CreateDNSRecord(this.record)
        .then(response => {
          this.displayNewRecordModal = false
          this.$toast.add({severity:'success', summary: 'Record created', detail:response.data.name, life: 3000});
        })
        .catch(error => {
          this.errors = error.response.data.errors
        })
        .finally(() => this.loading = false)
    },
    async saveRecord () {
      this.loading = true
      this.errors = {}
      
      this.UpdateDNSRecord(this.record)
        .then(response => {
          this.displayRecordModal = false
          this.record = {name: "", ttl: 3600}
          this.$toast.add({severity:'success', summary: 'Record updated', detail:response.data.name, life: 3000});
        })
        .catch(error => {
          this.errors = error.response.data.errors
        })
        .finally(() => this.loading = false)
    },
    async deleteRecord(record) {
      this.errors = {}
      
      this.$confirm.require({
          message: 'Are you sure you want to delete ' + record.name + '?',
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          acceptClass: 'p-button-danger',
          accept: () => {
            this.loading = true

            this.DeleteDNSRecord(record)
              .then(response => {
                this.displayRecordModal = false
                this.$toast.add({severity:'info', summary: 'Record deleted', life: 3000});
              })
              .catch(error => {
                this.errors = error.response.data.errors
              })
              .finally(() => this.loading = false)
          },
          reject: () => {
              //callback to execute when user rejects the action
          }
      });
    },
   
  }
}
</script>

<style scoped>
@media (max-width: 991px) {
  .truncate-name {
    width: 60vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: right;
  }
  .truncate-content {
    width: 60vw;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: right;
  }
}
@media (min-width: 992px) {
  .truncate-content {
    width: 40vw;
  }
}
</style>
